import React, { useMemo } from "react";
import Typography, { TypographyProps } from "@mui/material/Typography";

import cx from "classnames";
import { makeStyles } from "../../theme/Theme";
import { calculatePrice } from "../../helpers/PriceHelpers";
import { Breakpoints } from "../../dto/ApplicationDTO";

const useStyles = makeStyles((theme) => ({
  priceRoot: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    "&>.MuiTypography-root": {
      textWrap: "inherit",
      [theme.breakpoints.up(Breakpoints.Tablet)]: {
        textWrap: "nowrap",
      },
    },
  },
}));

export interface Props extends Omit<TypographyProps, "children"> {
  readonly price: number;
  readonly prefix?: string;
  readonly textClassName?: string;
  readonly currency?: Currency.Props;
}

export function Price({ price, currency, prefix, className, textClassName, ...props }: Props) {
  const classes = useStyles();

  const title = useMemo(() => {
    const calculatedPrice = calculatePrice(price, currency);

    return [prefix, calculatedPrice].filter(Boolean).join("");
  }, [currency, prefix, price]);

  return (
    <div className={cx(classes.priceRoot, className)}>
      <Typography variant="button1" {...props} className={textClassName}>
        {title}
      </Typography>
    </div>
  );
}
